import { render, staticRenderFns } from "./ForestPlot.vue?vue&type=template&id=7db9bc64&"
import script from "./ForestPlot.vue?vue&type=script&lang=js&"
export * from "./ForestPlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7db9bc64')) {
      api.createRecord('7db9bc64', component.options)
    } else {
      api.reload('7db9bc64', component.options)
    }
    module.hot.accept("./ForestPlot.vue?vue&type=template&id=7db9bc64&", function () {
      api.rerender('7db9bc64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ForestPlot.vue"
export default component.exports